import { marketIdFormat } from "@redotech/redo-xborder-outbound-id";
import * as z from "zod";
import { lcgQuoteBacktestRunOutput } from "./lcg-quote-backtest";

export const getLcgQuoteBacktest = {
  name: "getLcgQuoteBacktest" as const,
  input: z.object({ marketId: marketIdFormat.schema }),
  output: z.object({ run: lcgQuoteBacktestRunOutput.nullable() }),
};
